import { CatalogBuilder } from "../../../commonGroupModuleStructure/catalogBuilder";
import { getRolePagingData } from "./apiCall";
import { RoleKeys } from "./entity";

export const Role = () => {

  return (
    <CatalogBuilder
      headerLabel="Role"
      headerButtonLabel="Add Role"

      getPagingData={getRolePagingData}
      pagingAPIKey={RoleKeys.paging}

      visibleColumns={{
        ApplicationName: false
      }}
      onModeClickPath="/role/details/"
      disableDeleteAction
    />
  );
};
